"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalMediaList = ExternalMediaList;
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _models = require("../models");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ExternalMediaList(_ref) {
  let {
    medias,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Wrapper, props, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.external_media"
  })), medias.map(_ref2 => {
    let {
      id,
      type,
      title,
      url
    } = _ref2;
    const mediaType = _models.mediaTypesMap.find(_ref3 => {
      let {
        key
      } = _ref3;
      return key === type;
    });
    if (!mediaType) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: id
    });
    const {
      labelKey,
      Icon
    } = mediaType;
    return /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
      key: id,
      placement: "bottom",
      title: title || /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
        i18nKey: labelKey
      })
    }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
      component: "a",
      href: url,
      rel: "noreferrer",
      size: "small",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement(Icon, null)));
  }));
}
const Wrapper = _styledComponents.default.div`
  align-items: center;
  display: flex;
  gap: 8px;
  height: 36px;
  justify-content: flex-end;
  padding: 0 16px;
`;